var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResponsesIcon = function SvgResponsesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    fillRule: "evenodd",
    d: "m14.997 5.999-.012-.011.628-.755.013.01 1.28-1.539a1.943 1.943 0 0 1 2.754-.242l.722.611c.827.7.935 1.945.24 2.78l-8.81 10.59.009.02-.043.02-.012.015-.007-.006-5.075 2.481 1.38-5.61-.015-.013.024-.03.022-.09.044.011zm4.757-1.17-.722-.612a.97.97 0 0 0-1.377.122l-1.28 1.538 2.22 1.879 1.279-1.538a.99.99 0 0 0-.12-1.39M8.897 15.069l-.762 3.1 2.804-1.371zm6.849-8.436-6.32 7.596 2.22 1.88 6.32-7.597z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M0 19.505c0-.273.22-.494.49-.494h4.9c.27 0 .49.221.49.494 0 .274-.22.495-.49.495H.49a.49.49 0 0 1-.49-.495"
  })));
};
export default SvgResponsesIcon;